import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemText, Toolbar, AppBar, Typography, IconButton,
  Divider, Box,Collapse,Button } from '@mui/material';
import InventoryPage from '../auth/InventoryPage';
import WarehouseManager from './WarehouseManager';
import AdminProductUpload from './AdminProductUpload'; 
import { updateSupplierInfo } from '../service/supplierService'; // Service to call backend
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Header from '../components/SHeader';
import Footer from '../components/SFooter';
import AddProduct from '../auth/SupplierAddProduct';
import ApproveProduct from './ApproveProduct';
import VerifyProduct from './VerifyProduct';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import SupplierManager from './SupplierManager';
import SupplierAddressManager from './SupplierAddressManager';
import CertificateManager from './CertificateManager';

import DiscountManager from './DiscountManager';
import CouponManager from './CouponManager';
import ProductCommissionManager from './ProductCommissionManager';
import SubCategoryManager from './SubCategoryManager';
import CategoryManager from './CategoryManager';
import BrandManager from './BrandManager';
import OrderManagement from './OrderManagement';

import ProductManager from './ProductManager';
import ProductVariantManager from './ProductVariantManager';

import AdminGuidelines from './AdminGuidelines';
import ReferralManager from './ReferralManager';
import RefundManager from './RefundManager';
import ProductReviewManager from './ProductReviewManager';
import ZoneManager from './ZoneManager';
import ZonePincodeManager from './ZonePincodeManager';
import FulfillmentOrderManager from './FulfillmentOrderManager';
import ShipperRequest from './ShipperRequest';
import ShipperManager from './ShipperManager';
import AssignOrderToShipper from './AssignOrderToShipper';

const drawerWidth = 240;

export default function AdminDashboard() {

  const [selectedMenu, setSelectedMenu] = useState('Dashboard');

  const [supplierData, setSupplierData] = useState(null);
    
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
    
 const { user, logout } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = user || {};

  const toggleDrawer = () => {
    setOpen(!open);
  };
  
    const handleLogout = () => {
    logout(); 
     navigate('/adminlogin');

  };
    
    
  useEffect(() => {


  }, []);

  if (user === null) {
    return <div>Loading...</div>; 
  }
  
    const updateData = (key, value) => {
    setSupplierData(prev => ({ ...prev, [key]: value }));
  };

  if (!user) {
   // return <SupplierStepper />; // Supplier info not completed yet
      
       navigate('/suppliers');
  }
  
      const handleUpdate = async () => {
    try {
      console.log("dashboard : " , supplierData);
      await updateSupplierInfo(supplierData.supplierId, updateData);
      
        } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };

  // Supplier exists, show full dashboard
  const renderContent = () => {
    switch (selectedMenu) {
      case 'Supplier Manager':
        return <SupplierManager />;
      case 'Address Manager':
        return <SupplierAddressManager />;
      case 'Certificate Manager':
        return <CertificateManager />;
      case 'Warehouse Manager':
        return <WarehouseManager />;
      case 'Product Upload':
        return <AdminProductUpload />;
      case 'Add Product':
        return <AddProduct />;
      case 'Approve Products':
        return <ApproveProduct />;
      case 'Verify Products':
        return <VerifyProduct />;
      case 'Inventory':
        return <InventoryPage />;
      case 'Discount Manager':
        return <DiscountManager />;
      case 'Coupon Manager':
        return <CouponManager />;
      case 'ProductCommission Manager':
        return <ProductCommissionManager />;
      case 'Product Manager':
        return <ProductManager />;
      case 'ProductVariant Manager':
        return <ProductVariantManager />;
      case 'Category Manager':
        return <CategoryManager />;
      case 'SubCategory Manager':
        return <SubCategoryManager />;
      case 'Brand Manager':
        return <BrandManager />;  
      case 'Order Management':
        return <OrderManagement />;         
      case 'Referral Manager':
        return <ReferralManager />;  
      case 'Refund Manager':
        return <RefundManager />;
      case 'Review Manager':
        return <ProductReviewManager />;
      case 'Zone Manager':
        return <ZoneManager />;
      case 'ZonePincode Manager':
        return <ZonePincodeManager />;
      case 'FulfillmentOrder Manager':
        return <FulfillmentOrderManager />;
      case 'Shipper Request':
        return <ShipperRequest />;
      case 'Shipper Manager':
        return <ShipperManager />;
      case 'AssignOrder To Shipper':
        return <AssignOrderToShipper />;
      default:
        return <AdminGuidelines />;
    }
  };

  return (

   <>
  <AppBar position="static" sx={{ bgcolor: '#4D7B2B', color: '#FFFFFF' }}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
    {/* Title */}
    <Typography variant="h6" component="div">
      {selectedMenu === "Dashboard" ? "Dashboard" : selectedMenu}
    </Typography>

    <Box
            component="img"
            src="../images/foodsakzsidegraylogo.png" 
            alt="FoodSakz Logo"  
            sx={{ 
              height: 60,
              cursor: "pointer",
            }}
            onClick={() => navigate("/supplierdashboard")}
           />
  </Toolbar>
</AppBar>
        <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
  

<Box sx={{ display: "flex" }}>
      {/* Sidebar with toggle arrow */}
      <Collapse in={open} orientation="horizontal">
        <Box
          sx={{
            width: 250,
            borderRight: "1px solid #ddd",
            position: "relative",
            backgroundColor: "#fafafa",
            height: "100vh"
          }}
        >
         {/* Drawer */}
  <Drawer
    variant="persistent"
    anchor="left"
    open={open}
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: drawerWidth,
        boxSizing: "border-box",
        top: { xs: "56px", sm: "64px" }, // below AppBar
        height: { xs: "calc(100% - 56px)", sm: "calc(100% - 64px)" }
      }
    }}
  >
    <Typography variant="h6" component="div">
        Welcome {name}
    </Typography>
    <Button variant="outlined" color="inherit" onClick={handleLogout}>
          Logout
        </Button>
    <Divider />
        <List>
          {['Dashboard', 'Order Management', 'FulfillmentOrder Manager','Shipper Request', 'AssignOrder To Shipper','Shipper Manager', 'Supplier Manager', 'Referral Manager',  'Refund Manager', 'Review Manager', 'Address Manager', 'Certificate Manager', 'Warehouse Manager', 
           'Product Upload', 'Add Product', 'ProductVariant Manager', 'Product Manager', 'Approve Products', 'Verify Products','Inventory', 'Discount Manager','Coupon Manager',
           'ProductCommission Manager','Brand Manager','Category Manager','SubCategory Manager', 'Zone Manager', 'ZonePincode Manager'].map((text) => (
            <ListItem button key={text} onClick={() => setSelectedMenu(text)}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

          {/* Arrow button inside sidebar */}
          <IconButton
            onClick={toggleDrawer}
            sx={{
              position: "absolute",
              top: "50%",
              right: -20,
              transform: "translateY(-50%)",
              backgroundColor: "white",
              border: "1px solid #ccc",
              "&:hover": { backgroundColor: "#f0f0f0" }
            }}
            size="small"
          >
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      </Collapse>

      {/* Collapsed toggle button */}
      {!open && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            height: "40px",
            marginTop: "20px",
            "&:hover": { backgroundColor: "#f0f0f0" }
          }}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      )}
      <Box component="main"  sx={{
              flexGrow: 1,
              p: 3,
              transition: "margin 0.3s",
              marginLeft: open ? `${drawerWidth}px` : "0px",
            }}>
        <Toolbar />
        {renderContent()}
      </Box>
    </Box>
           <Footer />
     </Box>
</>
     
  );
}